import { createMuiTheme, createTheme } from "@material-ui/core";
import ZennyaTheme from './theme';

const themes = {
  default: createTheme({
    ...ZennyaTheme.light,
  }),
  dark: createTheme({
    ...ZennyaTheme.dark,
  }),
  createBooking: createTheme({
    ...ZennyaTheme.createBookingTheme,
  }),
  createBookingDark: createTheme({
    ...ZennyaTheme.createBookingThemeDark,
  })
};

export default themes;
